<template>
  <div
    class="calender-caption-component"
    :class="{ bulk: type === 'bulk' }"
    @click="itemClick"
  >
    <div class="icon" v-show="edit" :class="{ select: model.select }"></div>
    <div class="main-container">
      <div class="top-container">
        <div class="left-container">
          <div class="title" v-if="model.title">{{ model.title }}</div>
          <div class="text">{{ model.text }}</div>
        </div>
        <div
          class="default-icon-container"
          v-if="model.is_default && model.is_saved"
        >
          <div class="default-icon" v-if="model.is_default_on">default</div>
        </div>
      </div>
      <div v-if="model.date" class="date">{{ date }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "CaptionComponent",
  props: {
    model: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "normal",
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    itemClick() {
      this.$emit("click", this.model);
    },
  },
  computed: {
    /**
     * 日期格式化
     */
    date() {
      return moment(this.model.date).format("MMMM DD, YYYY");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

@active-color: @color-primary;
.calender-caption-component {
  font-size: 14px;
  border-bottom: 1px solid @border-color;
  padding: 15px 20px;
  cursor: pointer;
  background: white;
  display: flex;
  align-items: center;
  &.bulk {
    padding: 10px 0;
    font-size: 12px;
  }
  .icon {
    width: 24px;
    height: 24px;
    border: 1px solid #e5e5e5;
    border-radius: 50%;
    margin-right: 20px;
    &.select {
      background: url("../../../../public/images/schedule_posts/Select@3x.png");
      background-size: contain;
      border-width: 0;
    }
  }
  .main-container {
    flex: 1;
    .top-container {
      display: flex;
      .left-container {
        flex: 1;
        .title {
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 5px;
        }
        .text {
          white-space: pre-wrap;
          word-break: break-all;
        }
      }
      .default-icon-container {
        width: 50px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        margin-left: 10px;
        .default-icon {
          background: @theme-color;
          color: white;
          font-size: 8px;
          padding: 2px 4px;
          align-items: center;
          justify-content: center;
          display: block;
        }
      }
    }
    .date {
      margin-top: 10px;
      font-size: 12px;
      color: @font-color-gray;
      text-align: right;
    }
  }
  &:hover {
    color: @active-color;
    .date {
      color: @active-color;
    }
  }
}
</style>
